import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ObligationCarriersModel } from 'src/Models/ObligationGetLinkModel';
import { CarrierObligationService } from 'src/Services/carrier-obligation.service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';
import * as FileSaver from 'file-saver';	

@Component({
  selector: 'app-carrier-type-cfo',
  templateUrl: './carrier-type-cfo.component.html',
  styleUrls: ['./carrier-type-cfo.component.css']
})
export class CarrierTypeCfoComponent implements OnInit {

  stateCode: any;
  tokenKey: string;
  listofCarrier: ObligationCarriersModel[];
  listofCarrierExport: ObligationCarriersModel[];

  PageNumber: number = 1;
  PageSize: number;
  WhereCondition: string;
  OrderBy: string;
  CarrierName: string;


  upDowCarrierNameCSS: string = '';
  upDowSortOrderCSS: string = '';
  upDowActiveCSS: string = '';
  isAscending: boolean = false;
  isRecord: boolean = false;
  isloading: boolean = false;
  SelectedTool: string;
  totalRecordCount: number = 0;
  carrierTypeId: number = 0;
  openMenuIndex: number = -1;

  constructor(private readonly router: Router, 
    private readonly checkAuth: CheckAuth, 
    private readonly titleService: Title, 
    private readonly toastr: ToastrService,
    private readonly carrierObligationService: CarrierObligationService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.listofCarrier = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    this.WhereCondition = 'null';
    this.OrderBy = 'SortOrder';
    this.CarrierName = 'null';
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Carriers');

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {

    this.tokenKey = this.sessionStorageService.getTokenValue();
    if(this.SelectedTool == 'view 47'){
      this.SelectedTool = 'view47';
    }
    this.isloading = true;
    this.GetCarrier();
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetCarrier();
  }

  GetCarrier() {
    this.isloading = true;
    this.listofCarrier = [];
    if (this.CarrierName == "null") this.CarrierName = " ";
    this.carrierObligationService.GetAllCarrier(this.tokenKey, this.PageNumber, this.PageSize, this.CarrierName, this.OrderBy,false).subscribe(
      data => {
        this.isloading = false;
        this.listofCarrier = data['obligationcarrier'];
        if (this.listofCarrier != null) {
          if (this.listofCarrier.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofCarrier[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
      error => { this.stateCode = error }
    );
  }

  keywordFilters($event) {
    this.PageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.CarrierName = $event.target.value;
    else
      this.CarrierName = 'null';

    this.GetCarrier();
  }

  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';

      if (sortBy === "CarrierName") {
        this.upDowCarrierNameCSS = 'fa fa-arrow-down';
        this.upDowSortOrderCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "SortOrder") {
        this.upDowCarrierNameCSS = '';
        this.upDowSortOrderCSS = 'fa fa-arrow-down';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowCarrierNameCSS = '';
        this.upDowSortOrderCSS = '';
        this.upDowActiveCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "CarrierName") {
        this.upDowCarrierNameCSS = 'fa fa-arrow-up';
        this.upDowSortOrderCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "SortOrder") {
        this.upDowCarrierNameCSS = '';
        this.upDowSortOrderCSS = 'fa fa-arrow-up';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowCarrierNameCSS = '';
        this.upDowSortOrderCSS = '';
        this.upDowActiveCSS = 'fa fa-arrow-up';
      }
    }
    this.PageNumber = 1;
    this.GetCarrier();
  }

  addCarrier() {
    let navigation = '/admin/' + this.SelectedTool + '/carrier/manage';
    this.router.navigate([navigation]);
  }

  updateCarrier(carrierTypeId) {
    let navigation = '/admin/' + this.SelectedTool + '/carrier/manage/' + carrierTypeId;
    this.router.navigate([navigation]);
  }

  setDeleteData(id) {
    this.carrierTypeId = id;
  }


  deleteCarrier(carrierTypeId) {
    this.isloading = true;
    this.carrierObligationService.DeleteCarrier(this.tokenKey, carrierTypeId).subscribe(
      data => {
        this.isloading = false;
        if (data['status'] == 'Success') {
          if (data['message'] != "")
            this.showMessage(data['message'], 'Warning', 'warning')
          else
            this.showMessage("Carrier Deleted successfully", 'Success', 'success')
        }
        this.GetCarrier();
      },
      error => { this.stateCode = error }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportView47Carriers() {
    this.isloading = true;
    this.listofCarrierExport = [];
    if (this.CarrierName == "null") this.CarrierName = " ";
    this.carrierObligationService.GetAllCarrier(this.tokenKey, this.PageNumber, this.PageSize, this.CarrierName, this.OrderBy,true).subscribe(
      data => {
        this.listofCarrierExport = data['obligationcarrier'];
        if (this.listofCarrierExport != null) {
          if (this.listofCarrierExport.length > 0)
          {
            setTimeout(() => {
              this.DownloadView47Carriers();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else
        {
          this.isloading = false;
            this.toastr.error("No record found", "Error");
        }
      },
      error => { 
        this.isloading = false;
        console.log(error);
       }
    );
  }

  DownloadView47Carriers() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportView47Carriers';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportView47Carriers.xls");
  }
}
